import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CountryListActions from './Countrylist.action';
import { getData } from 'country-list';

@Injectable()
export class CountryListEffects {
  constructor(
    private actions$: Actions
  ) { }

  loadCountryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryListActions.loadCountryList),
      map(() => {
        try {
          const countries = getData();
          return CountryListActions.loadCountryListSuccess({ countries });
        } catch (error) {
          return CountryListActions.loadCountryListFailure({ error });
        }
      })
    )
  );
}
